import { motion } from "motion/react";
import { CalendarDays } from "lucide-react";
import { cn } from "@/lib/utils";
import { localDateString } from "@/lib/app-types";
import { addDays } from "@/lib/lecture-plan";

const today = () => localDateString();

export function DateField({
  value,
  onChange,
  label = "Completion date",
}: {
  value: string;
  onChange: (date: string) => void;
  label?: string;
}) {
  const quick = [
    { label: "Yesterday", date: addDays(today(), -1) },
    { label: "Today", date: today() },
    { label: "Tomorrow", date: addDays(today(), 1) },
  ];

  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {label}
      </p>
      <div className="mt-2.5 flex gap-2">
        {quick.map((item) => {
          const active = value === item.date;
          return (
            <motion.button
              key={item.label}
              type="button"
              whileTap={{ scale: 0.94 }}
              onClick={() => onChange(item.date)}
              className={cn(
                "relative flex-1 rounded-2xl px-3 py-2.5 text-[13px] font-semibold transition-colors",
                active
                  ? "text-primary-foreground"
                  : "border border-hairline bg-surface text-muted-foreground",
              )}
            >
              {active ? (
                <motion.span
                  layoutId="date-quick"
                  transition={{ type: "spring", stiffness: 320, damping: 30 }}
                  className="absolute inset-0 rounded-2xl [background-image:var(--gradient-brand)]"
                />
              ) : null}
              <span className="relative">{item.label}</span>
            </motion.button>
          );
        })}
      </div>
      <label className="mt-2.5 flex items-center gap-3 rounded-2xl border border-hairline bg-surface px-4 py-3">
        <CalendarDays className="size-4 shrink-0 text-primary" />
        <input
          type="date"
          value={value}
          onChange={(e) => e.target.value && onChange(e.target.value)}
          className="w-full bg-transparent text-[14px] font-medium outline-none [color-scheme:dark]"
        />
      </label>
    </div>
  );
}